import type { AgentSummary, Run, Task } from "../../types";
import { ColorDot, StatusBadge } from "../status-badge";
import { Card, CardAction, CardDescription, CardHeader, CardTitle } from "../ui/card";
import { StationRunDetail } from "./station-detail";

export function CurrentRunCard({
  run,
  task,
  agent,
  timeline = true,
  actions = true,
}: {
  run: Run;
  task: Task;
  agent: AgentSummary | undefined;
  timeline?: boolean;
  actions?: boolean;
}) {
  return (
    <Card>
      <CardHeader>
        <CardDescription>
          {run.id === task.currentRunId ? "Current station" : "Latest station"}
        </CardDescription>
        <CardTitle className="flex items-center gap-2 text-lg">
          {agent && <ColorDot color={agent.station.color} />}
          {agent?.name ?? run.agentId}
        </CardTitle>
        <CardAction>
          <StatusBadge status={run.status} />
        </CardAction>
      </CardHeader>
      <StationRunDetail
        run={run}
        task={task}
        agent={agent}
        framed="card"
        timeline={timeline}
        actions={actions}
      />
    </Card>
  );
}
